import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleModPriceUrls } from '@custom/Utils/constants/apiUrls';

type payloadType = {
  modality: string;
  credit: number;
  studyRegion: string;
};

// Async thunk to add a teleradiology customer
export const addTeleModPrice = createAsyncThunk(
  'addTeleModPrice',
  async (payload: payloadType, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_teleModPriceUrls?.add, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response?.ok) {
        return rejectWithValue(data);
      }

      return data; // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default addTeleModPrice;
